export default {
  title: 'Performances récentes des campagnes',
  recipients: '{{recipients}} destinataires',
  error_messages: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
